<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Vehicles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('drivers.plural')) }},
    resourceRoute: {default: 'drivers'},
    modelVariable: {default: 'driver'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo('drivers.create') } }
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('drivers.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('drivers.plural')),
          href: "/drivers",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        name: { type: String, label: this.lodash.startCase(this.$t('drivers.name')) },
        phone_number: { type: String, label: this.lodash.startCase(this.$t('drivers.phone_number')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['driver']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.startCase(this.$t('drivers.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">{{ item.name }}</div>'
            }
          },
          {
            key: 'license_plate',
            label: this.lodash.startCase(this.$t('drivers.phone_number')),
            thStyle: { minWidth: '100px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<span style="white-space: pre">{{ item.phone_number }}</span>'
            }
          },
          {
            key: 'description',
            label: this.lodash.startCase(this.$t('drivers.description')),
            thStyle: { minWidth: '400px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<div v-html="item.description"></div>'
            }
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/drivers/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/drivers', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    modelPolicy() {
      return {
        _denyShow: !this.$auth.hasPermissionTo('drivers.view'),
        _denyEdit: !this.$auth.hasPermissionTo('drivers.edit'),
        _denyDelete: !this.$auth.hasPermissionTo('drivers.delete'),
      }
    },
  },
};
</script>
